import CreateNewInfoPerson from "../APL/CreateNewInfoPerson";
import { useEffect, useState } from "react";
import Select from "react-select";
import { Card, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";

const APLInformationPersonModal = ({
  periodId,
  setInformationPersons,
  informationPersons,
  infoPersonUsers,
  setInfoPersonUsers,
  updateInfoPersonAddUsers,
  updateInfoPersonRemoveUsers,
  aplStudentSupervisors,
}) => {
  const intl = useIntl();
  const [selectableInfoPersons, setSelectableInfoPersons] = useState([]);
  const [selectableUsers, setSelectableUsers] = useState([]);

  useEffect(() => {
    let UsersForSelect = [];
    aplStudentSupervisors.forEach((stud) => {
      UsersForSelect.push({
        userType: "Student",
        value: stud,
        label: stud.name,
      });
      stud.supervisors.forEach((sv) => {
        let supervisorForSelect = {
          userType: "AplSupervisor",
          value: sv,
          label: sv.name,
        };
        UsersForSelect.push(supervisorForSelect);
      });
    });
    setSelectableUsers(UsersForSelect);

    let infoPersonsToSelect = [];
    let tempInfoPersonUsers = [];

    informationPersons.forEach((tInfoPerson, index) => {
      if (tInfoPerson.forUserIds && tInfoPerson.forUserIds.length > 0) {
        var tempUsers = [];
        tInfoPerson.forUsers.forEach((user) => {
          if (user.value) {
            tempUsers.push(user);
          } else {
            tempUsers.push({
              userType: user.userTypeOf,
              value: user,
              label: user.name,
            });
          }
        });

        tInfoPerson.forUsers = tempUsers;
        tempInfoPersonUsers.push(tInfoPerson);
      } else {
        infoPersonsToSelect.push({ label: tInfoPerson.name, value: index });
      }
    });

    setInfoPersonUsers(tempInfoPersonUsers);
    setSelectableInfoPersons(infoPersonsToSelect);
  }, [informationPersons, aplStudentSupervisors, setInfoPersonUsers]);

  const handleAddInfoPerson = (infoPerson) => {
    var tempInfoPerson = informationPersons[infoPerson.value];
    setInfoPersonUsers((infoPersonUsers) => [
      ...infoPersonUsers,
      tempInfoPerson,
    ]);
    let tempSelectableInfoPersons = selectableInfoPersons;
    tempSelectableInfoPersons.splice(infoPerson.value, 1);
    setSelectableInfoPersons(tempSelectableInfoPersons);
  };

  const handleRemoveInfoPerson = (infoPerson, index) => {
    if (infoPerson.forUsers.length > 0) {
      handleAddAndRemoveUsersToInfoPerson([], index);
    }

    var tempInfoPersonUsers = [...infoPersonUsers];
    tempInfoPersonUsers.splice(index, 1);
    setInfoPersonUsers(tempInfoPersonUsers);

    var tempSelectableInfoPersons = [...selectableInfoPersons];
    tempSelectableInfoPersons.push({ label: infoPerson.name, value: index });
    setSelectableInfoPersons(tempSelectableInfoPersons);
  };

  const handleAddAndRemoveUsersToInfoPerson = (users, infoPersonIndex) => {
    let infoPerson = infoPersonUsers[infoPersonIndex];
    let tempInfoPersonUsers = [...infoPersonUsers];
    if (infoPerson.forUsers.length > users.length) {
      //Find out which student was removed
      let removedUsers = infoPerson.forUsers.filter(function (user) {
        return users.indexOf(user) === -1;
      });

      //Update InfoPersonUsers
      tempInfoPersonUsers[infoPersonIndex].forUsers =
        users && users.length > 0 ? users : [];
      setInfoPersonUsers(tempInfoPersonUsers);
      infoPerson = tempInfoPersonUsers[infoPersonIndex];
      if (infoPerson.id) {
        let userIds = [];
        removedUsers.forEach((user) => {
          userIds.push(user.value.id);
        });
        updateInfoPersonRemoveUsers.mutate(
          {
            id: infoPerson.id,
            userIds: userIds,
          },
          {
            onSuccess: (data) => {
              var infoPersonId = data.data.result.id;
              var informationPersonIndex = informationPersons.findIndex(
                (person) => {
                  return person.id === infoPersonId;
                }
              );
              informationPersons[informationPersonIndex] = data.data.result;
              setInformationPersons(informationPersons);
            },
            throwOnError: true,
            onError: (data) => {
              toast.warn(data.response.data);
            },
          }
        );
      }
    } else {
      var dummyUserIndex = -1;
      let tempArray = [];
      if (
        users.findIndex((user) => {
          return user.value === "AllSupervisors";
        }) !== -1
      ) {
        users = users.filter((user) => user.userType !== "AplSupervisor");
        tempArray = selectableUsers.filter(
          (user) => user.userType === "AplSupervisor"
        );
        users.push(...tempArray);
        dummyUserIndex = users.findIndex((user) => {
          return user.value === "AllSupervisors";
        });
      } else if (
        users.findIndex((user) => {
          return user.value === "AllStudents";
        }) !== -1
      ) {
        users = users.filter((user) => user.userType !== "Student");
        tempArray = selectableUsers.filter(
          (user) => user.userType === "Student"
        );
        users.push(...tempArray);
        dummyUserIndex = users.findIndex((user) => {
          return user.value === "AllStudents";
        });
      }

      if (dummyUserIndex !== -1) {
        users.splice(dummyUserIndex, 1);
      }

      //Update InfoPersonUsers
      tempInfoPersonUsers[infoPersonIndex].forUsers = users;
      setInfoPersonUsers(tempInfoPersonUsers);

      infoPerson = tempInfoPersonUsers[infoPersonIndex];
      if (infoPerson.id) {
        let userIds = [];
        var tempInfoPersonUserIds = informationPersons.filter((obj) => {
          return obj.id === infoPerson.id;
        })[0].forUserIds;
        users.forEach((user) => {
          if (
            tempInfoPersonUserIds.findIndex((id) => {
              return id === user.value.id;
            }) < 0
          ) {
            userIds.push(user.value.id);
          }
        });

        if (userIds.length > 0) {
          updateInfoPersonAddUsers.mutate(
            {
              id: infoPerson.id,
              userIds: userIds,
            },
            {
              onSuccess: (data) => {
                var infoPersonId = data.data.result.id;
                var informationPersonIndex = informationPersons.findIndex(
                  (person) => {
                    return person.id === infoPersonId;
                  }
                );
                informationPersons[informationPersonIndex] = data.data.result;
                setInformationPersons(informationPersons);
              },
              throwOnError: true,
              onError: (data) => {
                toast.warn(data.response.data);
              },
            }
          );
        }
      }
    }
  };

  const InfoPersonsUsers = ({ intl }) => {
    if (infoPersonUsers.length > 0) {
      return infoPersonUsers.map((person, key) => {
        var selectableStudents = [];
        var selectableSupervisors = [];
        selectableUsers.forEach((user) => {
          if (
            person.forUsers.findIndex((forUser) => {
              return forUser.value
                ? forUser.value.id === user.value.id
                : forUser.id === user.value.id;
            }) < 0
          ) {
            if (user.userType === "Student") {
              selectableStudents.push(user);
            } else if (user.userType === "AplSupervisor") {
              selectableSupervisors.push(user);
            }
          }
        });

        if (selectableStudents.length > 1) {
          let AddAllStudents = {
            value: "AllStudents",
            userType: "SelectAllStudents",
            label: intl.formatMessage({
              id: "SelectAllStudentsInPeriod",
            }),
          };
          selectableStudents.unshift(AddAllStudents);
        }

        if (selectableSupervisors.length > 1) {
          let AddAllSupervisors = {
            value: "AllSupervisors",
            userType: "SelectAllSupervisors",
            label: intl.formatMessage({
              id: "SelectAllSupervisorsInPeriod",
            }),
          };
          selectableSupervisors.unshift(AddAllSupervisors);
        }

        const groupedOptions = [
          {
            label: "Elever",
            options: selectableStudents,
          },
          {
            label: "Handledare",
            options: selectableSupervisors,
          },
        ];

        return (
          <Card key={key} className="mt-4 mb-0">
            <CardHeader>
              <FontAwesomeIcon
                icon="circle-xmark"
                size="1x"
                className="me-3 text-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => handleRemoveInfoPerson(person, key)}
              />
              {person.name}
            </CardHeader>
            <Select
              menuPortalTarget={document.body}
              menuPosition={"fixed"}
              placeholder={intl.formatMessage({
                id: "ChooseWhoShouldHaveAccess",
              })}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              name="forUsers"
              defaultValue={person.forUsers}
              isMulti
              options={groupedOptions}
              onChange={(event) =>
                handleAddAndRemoveUsersToInfoPerson(event, key)
              }
              noOptionsMessage={({ inputValue }) => (
                <FormattedMessage id="NoPersonsInPeriodGoBackAndAdd" />
              )}
            />
          </Card>
        );
      });
    }
    return null;
  };

  return (
    <div>
      <CreateNewInfoPerson
        periodId={periodId}
        setInformationPersons={setInformationPersons}
        informationPersons={informationPersons}
      />

      <Select
        menuPortalTarget={document.body}
        menuPosition={"fixed"}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        name="infoPersons"
        placeholder={intl.formatMessage({
          id: "ChooseContactPerson",
        })}
        options={selectableInfoPersons}
        onChange={(event) => handleAddInfoPerson(event)}
        noOptionsMessage={({ inputValue }) => (
          <FormattedMessage id="NoContactPersonsAvailableCreateNew" />
        )}
      />
      <InfoPersonsUsers intl={intl} />
    </div>
  );
};

export default APLInformationPersonModal;
